import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { EndPointService } from 'src/app/core/services/end-point.service';
import { Observable } from 'rxjs';
import { Widget } from 'src/app/modules/framework/home-pages/models/Widget';
import { IWidgetsRow } from 'src/app/modules/framework/home-pages/models/IWidgetsRow';
import { IWidget } from 'src/app/modules/framework/home-pages/models/IWidget';
import { HomepageSetting } from '../models/HomepageSettings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class HomepageService {
  private _listDataLink = '/api/framework/ess/homepage/widgets';
  private _widgetsTree = '/api/framework/ess/homepage/widgetstree';
  private _settings = '/api/framework/ess/homepage/settings';
  private _settingsSave = '/api/framework/ess/homepage/settings/save';
  private _widgetsSave = '/api/framework/ess/homepage/widgets/save';

  constructor(
    private _endPointService: EndPointService,
    private http: HttpClient
  ) {
    this.registerEndPoints();
  }

  private registerEndPoints(): void {
    this._endPointService.registerEndPoint<Widget[]>(
      'homewidgets_get',
      this._listDataLink
    );
    this._endPointService.registerEndPoint<IWidgetsRow[]>(
      'homewidgets_get_tree',
      this._widgetsTree
    );
    this._endPointService.registerEndPoint<void>(
      'home_widgets_save',
      this._widgetsSave,
      false
    );

    this._endPointService.registerEndPoint<HomepageSetting[]>(
      'home_settings',
      this._settings
    );
    this._endPointService.registerEndPoint<HomepageSetting[]>(
      'home_settings_save',
      this._settingsSave,
      false
    );
  }

  public getWidgets(fetch?: boolean): Observable<Widget[]> {
    return this._endPointService
      .call<IWidget[]>('homewidgets_get', null, fetch)
      .pipe(
        map((widgets: IWidget[]) => {
          return widgets.map((e: IWidget) => new Widget(e));
        })
      );
  }

  public getWidgetsTree(fetch?: boolean): Observable<IWidgetsRow[]> {
    return this._endPointService
      .call<IWidgetsRow[]>('homewidgets_get_tree', null, fetch)
      .pipe(
        map((rows: IWidgetsRow[]) => {
          return rows.map((r) => {
            r.widgetsColumns = r.widgetsColumns.map((c) => {
              c.widgets = c.widgets.map((e: IWidget) => new Widget(e));
              return c;
            });
            return r;
          });
        })
      );
  }

  public saveWidgetsOrder(
    widgets: IWidgetsRow[],
    fetch?: boolean
  ): Observable<void> {
    for (const widgetRow of widgets) {
      for (const widgetColumns of widgetRow.widgetsColumns) {
        for (const widget of widgetColumns.widgets) {
          for (const sp of widget.menuItem.subPages) {
            sp.parent = null;
            for (const ssp of sp.subPages) {
              ssp.parent = null;
              for (const sssp of ssp.subPages) {
                sssp.parent = null;
                for (const ssssp of sssp.subPages) {
                  ssssp.parent = null;
                }
              }
            }
          }

          for (const ws of widget.widgetSections) {
            ws.menuItem.parent = null;
            for (const sp of ws.menuItem.subPages) {
              sp.parent = null;
              for (const ssp of sp.subPages) {
                ssp.parent = null;
                for (const sssp of ssp.subPages) {
                  sssp.parent = null;
                  for (const ssssp of sssp.subPages) {
                    ssssp.parent = null;
                  }
                }
              }
            }
          }
        }
      }
    }
    return this._endPointService.call<void>('home_widgets_save', widgets);
  }

  public getSettings(fetch?: boolean): Observable<HomepageSetting[]> {
    return this._endPointService.call<HomepageSetting[]>(
      'home_settings',
      null,
      fetch
    );
  }

  public saveSettings(
    settings: HomepageSetting[],
    widgets: Widget[],
    fetch?: boolean
  ): Observable<HomepageSetting[]> {
    for (const widget of widgets) {
      widget.menuItem.parent = null;

      for (const sp of widget.menuItem.subPages) {
        sp.parent = null;
        for (const ssp of sp.subPages) {
          ssp.parent = null;
          for (const sssp of ssp.subPages) {
            sssp.parent = null;
            for (const ssssp of sssp.subPages) {
              ssssp.parent = null;
            }
          }
        }
      }

      for (const ws of widget.widgetSections) {
        ws.menuItem.parent = null;
        for (const sp of ws.menuItem.subPages) {
          sp.parent = null;
          for (const ssp of sp.subPages) {
            ssp.parent = null;
            for (const sssp of ssp.subPages) {
              sssp.parent = null;
              for (const ssssp of sssp.subPages) {
                ssssp.parent = null;
              }
            }
          }
        }
      }
    }
    return this._endPointService.call<HomepageSetting[]>('home_settings_save', {
      settings: settings,
      widgets: widgets,
    });
  }

  public saveWidgetIcon(widget: Widget): Observable<void> {
    return this.http.post<void>('/api/framework/ess/homepage/widgets/save-icon/', widget);
  }

  public getWidgetByAngularComponent(angularComponent: string): Observable<Widget> {
    return this.http.post<Widget>('/api/framework/ess/homepage/widgets/getby-angularcomponent/' + angularComponent, null);
  }
}
